<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 10px;border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" v-if="activeName == item.name" :forwarder="forwarder" :countryList="countryList"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  forwarderList_outStock,
  taskCountryList
} from "@/apis/outStock";
import fbaShip from './fbaShip'
import largeBagShip from '@/views/outOfStock/internationalShipment/largeBagShip'
import smallBagShip from '@/views/outOfStock/internationalShipment/smallBagShip'

export default {
  name: "InternationalInvoice", // 国际发货单列表
  components: {
    fbaShip,
    largeBagShip,
    smallBagShip
  },
  data() {
    return {
      activeName: fbaShip.name,
      forwarder: [],
      countryList: []
    }
  },
  computed: {
    comList: function () {
      return [fbaShip, largeBagShip, smallBagShip]
      // return [fbaShip, largeBagShip]
    }
  },
  mounted(){
    forwarderList_outStock().then(({code,data})=>{
        if(code === 0){
          this.forwarder = data;
        }
    })
    taskCountryList().then(({code,data})=>{
        if(code === 0){
          this.countryList = data.filter(v=>v.countryName == '日本' || v.countryName == '韩国'|| v.countryName == '中国').concat(data.filter(v=>v.countryName != '日本' && v.countryName != '韩国' && v.countryName != '中国'));
        }
    })
  },
  methods: {
    handleClick(tab, event) {
    },
    scrollCall(res) {
      console.log(res.target.scrollLeft)
      this.targetLeft = res.target.scrollLeft
    },
  }
}
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>